import React, { Suspense } from "react";

import "./IntlPolyfills";

import { GestureHandlerRootView } from "react-native-gesture-handler";

import { AppProvider } from "./Provider";
import { LoginBranch } from "./LoginBranch";
import { SafeAreaProvider } from "react-native-safe-area-context";
import { AHQueryHandlerLoading } from "arkh";

import { PersistGate } from "redux-persist/integration/react";
import { persistor } from "./Store";
import * as Sentry from "@sentry/react-native";

import "./global.css";
import { TimeZoneProvider } from "./Timezone";
import { WorkspaceTimeZoneProvider } from "./WorkspaceTimezone";

import { IconPlayground } from "../misc/IconPlayground";

const APP = () =>
  process.env.EXPO_PUBLIC_PLAYGROUND ? (
    <AppProvider>
      <IconPlayground />
    </AppProvider>
  ) : (
    <Suspense fallback={<AHQueryHandlerLoading />}>
      <GestureHandlerRootView style={{ flex: 1 }}>
        <SafeAreaProvider>
          <PersistGate persistor={persistor}>
            <TimeZoneProvider>
              <WorkspaceTimeZoneProvider>
                <AppProvider>
                  <Suspense fallback={<AHQueryHandlerLoading />}>
                    <LoginBranch />
                  </Suspense>
                </AppProvider>
              </WorkspaceTimeZoneProvider>
            </TimeZoneProvider>
          </PersistGate>
        </SafeAreaProvider>
      </GestureHandlerRootView>
    </Suspense>
  );

export const OS = Sentry.wrap(APP);
